import { ColDef, ColGroupDef, ITooltipParams } from "ag-grid-community";


export const headers: (ColDef | ColGroupDef)[] =
[
    {headerName:"", field: "type", pinned: 'left', cellStyle:{ fontWeight: '700' }, width: 145, flex: 1, cellRenderer: (prop:any) => {return rowHeadingNameAdjustment(prop.value)}},
    {headerName: "Script Count",  field: "scriptCount", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }},
    {headerName: "Patient Cont",  headerTooltip:"Patient Contribution", field: "patientCost", type: 'rightAligned', minWidth: 140, cellRendererParams: { align: "right" }, flex: 1, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Gov Cont",  headerTooltip:"Government Contribution", field: "govRecoveryCost", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "GST", field: "patientGST", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Sales Value", field: "salesValue", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Last Inv", field: "basePrice", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Average Cost", field: "basePrice", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "PBS/WS1", field: "basePrice", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Gross Profit", field: "grossProfit", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Markup", field: "markup", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Fees", field: "fees", type: 'rightAligned', minWidth: 140, flex: 1, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "Surcharges", field: "surcharges", minWidth: 140, flex: 1, type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},    
    {headerName: "GP % Sales",  headerTooltip:"Gross Profit % Sales", field: "gpSalesPercentage", minWidth: 140, flex: 1, type: 'rightAligned',  cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "GP % Base",  headerTooltip:"Gross Profit % Base Profit", field: "gpBasePercentage", minWidth: 140, flex: 1, type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "Fee % Sales", field: "feeSalesPercentage", minWidth: 140, flex: 1, type: 'rightAligned',  cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }}, 
    {headerName: "Fee % GP",  headerTooltip:"Fee % Gross Profit", field: "feeGPPercentage", minWidth: 140, flex: 1, type: 'rightAligned',  cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},    
    {headerName: "Incentive", field: "premFreeIncentive", minWidth: 140, flex: 1, type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "e-Script Fee", field: "eScriptIncentive", minWidth: 140, flex: 1, type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}, 
    {headerName: "PBS Discount", headerTooltip:"PBS Copayment Discount", field: "pbsDiscount", minWidth: 140, flex: 1, type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }}
]


function rowHeadingNameAdjustment(headingName:string){
    let formattedHeader ="";

    switch(headingName){
        case "SafetyNet":
            formattedHeader = "Safety Net";
            break;

        case "GenNHS":
            formattedHeader = "Gen NHS";
            break;
        
        case "Emerg Bag":
            formattedHeader = "Emergency Bag";
            break;

        case "GovtSubt.":
            formattedHeader = "Govt Subt.";
            break;

        default:
            formattedHeader = headingName;
            break;
    }

    return <>{formattedHeader}</>;
}